import * as React from 'react';
import './SubscriptionFilter.css';

export enum FiltreSubState {
    TOUS = 0,
    EN_COURS = 1,
    A_VALIDER = 2,
    VALIDEE = 3,
}

export enum FieldSort {
    PSEUDO_ASC,
    PSEUDO_DEC,
}

interface Props {
    setSubStateFilter: (filtre: FiltreSubState) => void;
    subTypeFilter: FiltreSubState;
    setFieldSort: (sort: FieldSort) => void;
    subFieldSort: FieldSort;
}

interface State {
}

/**
 * Ce composant permet d'afficher la
 */
export class SubscriptionFilter extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="row col-12">
                <div className=" row col-5" style={{float: 'right'}}>
                    <strong style={{marginTop: '34px', fontSize: '19px', marginRight: '20px'}}>
                        Filtrer:
                    </strong><this.FilterSelect />
                </div>
                <div className=" row col-6">
                    <strong style={{marginTop: '34px', fontSize: '19px', marginRight: '20px'}}>
                        Trier: </strong><this.SortSelect />
                </div>
            </div>
        );
    }

    private FilterSelect = () => {
        return (
            <select
                style={{marginTop: '30px', marginBottom: '30px'}}
                onChange={
                    (e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.props.setSubStateFilter(Number.parseInt(e.currentTarget.value));
                    }
                }
                className="form-control col-6"
                value={this.props.subTypeFilter}
            >
                <option key={FiltreSubState.TOUS} value={FiltreSubState.TOUS}>
                    Tous
                </option>
                <option key={FiltreSubState.A_VALIDER} value={FiltreSubState.A_VALIDER}>
                    A valider
                </option>
                <option key={FiltreSubState.EN_COURS} value={FiltreSubState.EN_COURS}>
                    En cours
                </option>
                <option key={FiltreSubState.VALIDEE} value={FiltreSubState.VALIDEE}>
                    Validée
                </option>
            </select>
        );
    }

    private SortSelect = () => {
        return (
            <select
                style={{marginTop: '30px', marginBottom: '30px'}}
                onChange={
                    (e: React.ChangeEvent<HTMLSelectElement>) => {
                        this.props.setFieldSort(Number.parseInt(e.currentTarget.value));
                    }
                }
                className="form-control col-4"
                value={this.props.subFieldSort}
            >
                <option key={FieldSort.PSEUDO_ASC} value={FieldSort.PSEUDO_ASC}>
                    Pseudo A-Z
                </option>
                <option key={FieldSort.PSEUDO_DEC} value={FieldSort.PSEUDO_DEC}>
                    Pseudo Z-A
                </option>
            </select>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SubscriptionManagmentPage/internalComponents/SubscriptionFilter.tsx